import './index.scss';
import { Application, Controller } from 'utils/stimulus';
import { trackViewFreemiumTrainerEvent } from '../utils';

export default class FreemiumTrainerModal extends Controller {
  static targets = [
    'modal',
    'modalOverlay',
    'floatingButton',
    'loading',
    'disciplineType',
    'disciplineName',
    'disciplineSolved',
    'disciplinePercentage',
    'disciplinePracticeLink',
    'subjectType',
    'subjectName',
    'subjectSolved',
    'subjectPercentage',
    'subjectPracticeLink',
    'firstSectionTitle',
    'secondSectionTitle',
    'thirdSectionTitle',
    'firstSectionPopup',
    'secondSectionPopup',
    'thirdSectionPopup'
  ];

  isModalOpen = false;

  get isStandardType() {
    return this.modalTarget.dataset.type === 'standard';
  }

  get isInviteType() {
    return this.modalTarget.dataset.type === 'invite';
  }

  connect() {
    this.on('openFreemiumTrainerModal', this.openModal.bind(this));

    if (this.hasFloatingButtonTarget) {
      $(document).scroll(this.showFloatingButtonAfterScroll.bind(this));
    }

    if (window.location.href.includes('questoes')) {
      trackViewFreemiumTrainerEvent('floating button', {
        invite: this.isInviteType
      });
    }
  }

  showFloatingButtonAfterScroll() {
    if (!this.hasFloatingButtonTarget || this.isModalOpen) {
      return;
    }

    if (window.scrollY > 300) {
      this.showFloatingButton();
    } else {
      this.hideFloatingButton();
    }
  }

  handleMinimizeButtonClick() {
    this.closeModal();
    this.showFloatingButton();
  }

  handleCloseButtonClick() {
    this.closeModal();
    this.removeFloatingButton();
  }

  handleFloatingButtonClick() {
    this.openModal();
  }

  handlePracticeButtonClick(e) {
    const { link } = e.currentTarget.dataset;

    window.location.href = link;
  }

  openModal() {
    this.isModalOpen = true;

    this.hideFloatingButton();
    this.trigger('freemium-trainer-filter-banner->close');
    this.trigger('freemium-trainer-panel->notifyNotificationOpened');

    if (this.hasFloatingButtonTarget) {
      this.floatingButtonTarget.classList.remove(
        'q-freemium-trainer-floating-button--notification'
      );
    }

    if (this.isStandardType) {
      this.fetchModalContent();
    }

    this.modalOverlayTarget.classList.add('q-freemium-trainer-overlay--show');
    this.modalTarget.classList.add('q-freemium-trainer--show');
  }

  closeModal() {
    this.isModalOpen = false;

    this.modalOverlayTarget.classList.remove(
      'q-freemium-trainer-overlay--show'
    );
    this.modalTarget.classList.remove('q-freemium-trainer--show');
  }

  showFloatingButton() {
    if (!this.hasFloatingButtonTarget || this.isModalOpen) {
      return;
    }

    $(this.floatingButtonTarget).fadeIn();
  }

  hideFloatingButton() {
    if (!this.hasFloatingButtonTarget) {
      return;
    }

    $(this.floatingButtonTarget).fadeOut();
  }

  removeFloatingButton() {
    if (!this.hasFloatingButtonTarget) {
      return;
    }

    this.floatingButtonTarget.remove();
  }

  fetchModalContent() {
    this.loadingTarget.classList.add('loading-container--show');

    Thor.CoachFreemium.show(
      {
        userId: currentUser.id
      },
      {}
    )
      .then(response => {
        this.disciplineTypeTarget.textContent = this.getDisciplineTypeText(
          response.performance_type
        );
        this.disciplineNameTarget.textContent = response.discipline.name;
        this.disciplineSolvedTarget.textContent = response.discipline.solved;
        this.disciplinePercentageTarget.textContent =
          response.discipline.correct_percentage + '%';
        this.disciplinePracticeLinkTarget.setAttribute(
          'data-link',
          response.discipline.practice_link
        );

        this.subjectTypeTarget.textContent = this.getSubjectTypeText(
          response.performance_type
        );
        this.subjectNameTarget.textContent = response.subject.name;
        this.subjectSolvedTarget.textContent = response.subject.solved;
        this.subjectPercentageTarget.textContent =
          response.subject.correct_percentage + '%';
        this.subjectPracticeLinkTarget.setAttribute(
          'data-link',
          response.subject.practice_link
        );

        this.firstSectionTitleTarget.textContent = this.getSectionTitle(
          response.performance_type
        );
        this.firstSectionPopupTarget.setAttribute(
          'title',
          this.getSectionPopup(response.performance_type)
        );
        this.secondSectionTitleTarget.textContent = this.getSectionTitle(
          response.blured_performance_types[0]
        );
        this.secondSectionPopupTarget.setAttribute(
          'title',
          this.getSectionPopup(response.blured_performance_types[0])
        );
        this.thirdSectionTitleTarget.textContent = this.getSectionTitle(
          response.blured_performance_types[1]
        );
        this.thirdSectionPopupTarget.setAttribute(
          'title',
          this.getSectionPopup(response.blured_performance_types[1])
        );
      })
      .catch(error => {
        this.closeModal();
        Rollbar.error(
          '[front] Falha ao exibir o Freemium do Treinador.',
          error
        );
        toastr.error(
          'Ocorreu um erro ao carregar os dados do Treinador, tente novamente mais tarde.'
        );
      })
      .finally(() => {
        this.loadingTarget.classList.remove('loading-container--show');
      });
  }

  getSectionTitle(type) {
    const typeMap = {
      weak: 'Seus pontos Fracos',
      critical: 'Seus pontos Críticos',
      strong: 'Seus pontos Fortes'
    };

    return typeMap[type];
  }

  getSectionPopup(type) {
    const typeMap = {
      weak: 'São considerados <strong>pontos fracos</strong> as disciplinas ou assuntos cujo seu desempenho ficou <strong>entre 50% e 75%</strong>',
      critical:
        'São considerados <strong>pontos críticos</strong> as disciplinas ou assuntos cujo seu desempenho foi <strong>inferior a 50%</strong>',
      strong:
        'São considerados <strong>pontos fortes</strong> as disciplinas ou assuntos cujo seu desempenho foi <strong>superior a 75%</strong>'
    };

    return typeMap[type];
  }

  getDisciplineTypeText(type) {
    const typeMap = {
      weak: 'DISCIPLINA MAIS FRACA',
      critical: 'DISCIPLINA MAIS CRÍTICA',
      strong: 'DISCIPLINA MAIS FORTE'
    };

    return typeMap[type];
  }

  getSubjectTypeText(type) {
    const typeMap = {
      weak: 'ASSUNTO MAIS FRACO',
      critical: 'ASSUNTO MAIS CRÍTICO',
      strong: 'ASSUNTO A MELHORAR'
    };

    return typeMap[type];
  }
}

global.FreemiumTrainerApplication =
  global.FreemiumTrainerApplication || Application.start();
global.FreemiumTrainerApplication.register(
  'freemium-trainer-modal',
  FreemiumTrainerModal
);
